(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-bumpino-category-rail]').forEach(rail => {
      if (rail.dataset.railReady) return;
      rail.dataset.railReady = 'true';
      const track = rail.querySelector('[data-rail-track]');
      const links = [...track.querySelectorAll('a')];
      const previous = rail.querySelector('[data-rail-previous]');
      const next = rail.querySelector('[data-rail-next]');
      if (!links.length) return;
      const rtl = document.documentElement.dir === 'rtl';
      let index = Math.max(0, links.findIndex(link => link.matches('[aria-current="page"]') || link.closest('.t4s-current-cat')));
      const reduced = () => window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
      const beyondPrevious = (bounds, viewport) => rtl ? bounds.right > viewport.right + 2 : bounds.left < viewport.left - 2;
      const beyondNext = (bounds, viewport) => rtl ? bounds.left < viewport.left - 2 : bounds.right > viewport.right + 2;
      const refresh = (syncPosition = false) => {
        const viewport = track.getBoundingClientRect();
        const first = links[0].parentElement.getBoundingClientRect();
        const last = links.at(-1).parentElement.getBoundingClientRect();
        const morePrevious = beyondPrevious(first, viewport);
        const moreNext = beyondNext(last, viewport);
        rail.toggleAttribute('data-more-previous', morePrevious);
        rail.toggleAttribute('data-more-next', moreNext);
        if (syncPosition) {
          const center = (viewport.left + viewport.right) / 2;
          const distances = links.map(link => {
            const bounds = link.parentElement.getBoundingClientRect();
            return Math.abs((bounds.left + bounds.right) / 2 - center);
          });
          index = distances.indexOf(Math.min(...distances));
        }
        previous.disabled = !morePrevious;
        next.disabled = !moreNext;
      };
      const reveal = (newIndex, focus = false) => {
        index = Math.max(0, Math.min(links.length - 1, newIndex));
        const link = links[index];
        // Align the target with its snap position so a small overflow cannot snap back.
        link.scrollIntoView({block: 'nearest', inline: 'start', behavior: reduced() ? 'instant' : 'smooth'});
        if (focus) link.focus({preventScroll: true});
        refresh();
      };
      const revealOverflow = forward => {
        const viewport = track.getBoundingClientRect();
        const positions = links.map((link, position) => position);
        if (!forward) positions.reverse();
        const isBeyond = forward ? beyondNext : beyondPrevious;
        const target = positions.find(position => isBeyond(links[position].parentElement.getBoundingClientRect(), viewport));
        if (target !== undefined) reveal(target);
      };
      previous.addEventListener('click', () => revealOverflow(false));
      next.addEventListener('click', () => revealOverflow(true));
      track.addEventListener('focusin', event => {
        const focusedIndex = links.indexOf(event.target);
        if (focusedIndex >= 0) { index = focusedIndex; reveal(index); }
      });
      track.addEventListener('keydown', event => {
        const focusedIndex = links.indexOf(event.target.closest('a'));
        if (focusedIndex >= 0) index = focusedIndex;
        let target;
        if (event.key === 'Home') target = 0;
        if (event.key === 'End') target = links.length - 1;
        if (event.key === 'ArrowRight') target = index + (rtl ? -1 : 1);
        if (event.key === 'ArrowLeft') target = index + (rtl ? 1 : -1);
        if (target === undefined) return;
        event.preventDefault(); reveal(target, true);
      });
      track.addEventListener('scroll', () => refresh(true), {passive: true});
      window.addEventListener('resize', () => refresh(), {passive: true});
      if (window.ResizeObserver) new ResizeObserver(() => refresh()).observe(track);
      reveal(index);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once: true});
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
